import { DocumentFile } from 'src/app/product-capture/model/interfaces/document-file.interface';
import { DocDetails, DocumentComparisonFileTypes } from './documents.model';

export const DocumentUtils = {
  getDocumentDetails: (base64: string, file: DocumentFile): DocDetails => ({
    base64,
    type: DocumentUtils.getFileExtension(file),
  }),
  getFileExtension: (file: DocumentFile): DocumentComparisonFileTypes =>
    file.fileUrl.split('.').pop() as DocumentComparisonFileTypes,

  formatSize: (size: number): string => {
    const units = [
      'bytes',
      'KiB',
      'MiB',
      'GiB',
      'TiB',
      'PiB',
      'EiB',
      'ZiB',
      'YiB',
    ];

    let length = 0,
      n = size || 0;

    while (n >= 1024 && ++length) {
      n = n / 1024;
    }

    return n.toFixed(n < 10 && length > 0 ? 1 : 0) + ' ' + units[length];
  },
};
